"use client";

import { useEffect, useState } from "react";
import { Card, Table, Spinner } from "react-bootstrap";
import { getWalletSummary, getWalletTransactions } from "../../services/store";

const StoreWalletComp = () => {
  const [wallet, setWallet] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const [summary, txs] = await Promise.all([
          getWalletSummary(),
          getWalletTransactions(),
        ]);
        setWallet(summary);
        setTransactions(txs);
      } catch (err) {
        console.error("Error loading wallet:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
        <p>در حال بارگذاری اطلاعات کیف پول...</p>
      </div>
    );
  }

  return (
    <>
      {/* Summary */}
      <Card className="bg-primary border-0 rounded-3 mb-4 text-white">
        <Card.Body className="p-4">
          <h4 className="fw-semibold mb-3">کیف پول فروشگاه</h4>
          <p className="mb-1">موجودی فعلی: {wallet?.balance?.toLocaleString()} تومان</p>
          <p className="mb-0">آخرین به‌روزرسانی: {wallet?.updatedAt}</p>
        </Card.Body>
      </Card>

      {/* Transactions */}
      <Card className="border-0 rounded-3">
        <Card.Body>
          <h5 className="fw-semibold mb-3">تراکنش‌ها</h5>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>تاریخ</th>
                <th>شرح</th>
                <th>مبلغ</th>
                <th>نوع</th>
              </tr>
            </thead>
            <tbody>
              {transactions.length > 0 ? (
                transactions.map((tx) => (
                  <tr key={tx.id}>
                    <td>{tx.date}</td>
                    <td>{tx.description}</td>
                    <td>{tx.amount.toLocaleString()} تومان</td>
                    <td>{tx.type === "credit" ? "واریز" : "برداشت"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    هیچ تراکنشی یافت نشد
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  );
};

export default StoreWalletComp;
